import React from 'react'
import "./BlogPost.css";

import senyor1 from "../../Assets/b60/senyor1.jpg"
import senyor2 from "../../Assets/b60/senyor2.jpg"
import senyor3 from "../../Assets/b60/senyor3.jpg"
import senyor4 from "../../Assets/b60/senyor4.jpg"

function Blog60() {
    return (
        <div className='container-fluid my-5'>
            <div className='row mb-5'>
                <div className='col blog-text text-center'>
                    <h1>Pit Senyor from MYT!</h1>
                    <h6>January 19, 2025 at 01:31 PM</h6>
                </div>
            </div>

            <div className='row align-items-center justify-content-center mx-5 gx-5 gy-5'>
                <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-5 col-xxl-5'>
                    <img src={senyor1} className="blog-img" alt="..." />
                </div>
                <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 blog-text'>
                    <p>Wishing everyone a joyful and meaningful Sinulog celebration! 🌟❤️</p>
                    <p><a href='https://www.facebook.com/hashtag/pitsenyor' target='_blank' className='blog-link'>
                        #PitSenyor</a>
                        <a href='https://www.facebook.com/hashtag/sinulog2025' target='_blank' className='blog-link'>
                        #Sinulog2025</a>
                        <a href='https://www.facebook.com/hashtag/myt' target='_blank' className='blog-link'>
                        #MYT </a>
                    </p>
                </div>
            </div>
        </div>
    )
}

export default Blog60
